import * as React from 'react';

import Wysiwyg from '../Wysiwyg';

import s from './Fact.module.scss';

export interface FactProps {
    title?: string;
    content?: string;
}

const Fact: React.FC<FactProps> = ({ title, content }) => {
    return (
        <div className={s.Root}>
            <h2 className={s.Title}>{title}</h2>
            <Wysiwyg html={content} />
        </div>
    );
};

export default Fact;
